import { adminServerInstance } from "../axios/instances";
import { SORTING_MACHINE as type } from './types';

export function getMachineSlots(machineCode) {
    return function (dispatch) {
        dispatch({ type: type.GET_MACHINE_SLOTS })
        return adminServerInstance.get(`/sortmachine/getmachineslots?machine_code=${machineCode}`)
            .then(({ data }) => {
                dispatch({
                    type: type.GET_MACHINE_SLOTS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.GET_MACHINE_SLOTS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function handleCurrentConfig(configId, isActive) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_CURRENT_CONFIG })
        return (
            dispatch({
                type: type.HANDLE_CURRENT_CONFIG,
                payload: {
                    configId: configId,
                    isActive: isActive
                }
            })
        )
    }
}

/**
 * @param {string} config_id
 */
export function deleteSortingConfig(params) {
    return function (dispatch) {
        dispatch({ type: type.DELETE_SORTING_CONFIG })
        return adminServerInstance.post(`/sortmachine/delsortingconfig`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.DELETE_SORTING_CONFIG_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.DELETE_SORTING_CONFIG_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getAllRoutes(warehouse) {
    return function (dispatch) {
        dispatch({ type: type.GET_ALL_ROUTES })
        return adminServerInstance.get(`/sortmachine/getallroutes?warehouse=${warehouse}`)
            .then(({ data }) => {
                dispatch({
                    type: type.GET_ALL_ROUTES_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.GET_ALL_ROUTES_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function querySortingConfigs(machineCode, sortingType) {
    return function (dispatch) {
        dispatch({ type: type.QUERY_SORTING_CONFIGS })
        return adminServerInstance.get(`/sortmachine/querysortingconfigs?machine_code=${machineCode}&sorting_type=${sortingType}`)
            .then(({ data }) => {
                dispatch({
                    type: type.QUERY_SORTING_CONFIGS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.QUERY_SORTING_CONFIGS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {string} name
 * @param {string} machine_code
 * @param {string} sorting_type
 * @param {array} config_items {sorting_number, grid, warehouse}
 */
export function addSortingConfig(params) {
    return function (dispatch) {
        dispatch({ type: type.ADD_SORTING_CONFIG })
        return adminServerInstance.post(`/sortmachine/addsortingconfig`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.ADD_SORTING_CONFIG_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.ADD_SORTING_CONFIG_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {string} config_id
 * @param {string} name
 * @param {string} machine_code
 * @param {string} sorting_type
 * @param {array} config_items {sorting_number, grid, warehouse}
 */
export function updateSortingConfig(params) {
    return function (dispatch) {
        dispatch({ type: type.UPDATE_SORTING_CONFIG })
        return adminServerInstance.post(`/sortmachine/updatesortingconfig`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.UPDATE_SORTING_CONFIG_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.UPDATE_SORTING_CONFIG_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {string} config_id
 * @param {string} machine_code
 */
export function setCurrentPlan(params) {
    return function (dispatch) {
        dispatch({ type: type.SET_CURRENT_PLAN })
        return adminServerInstance.post(`/sortmachine/setcurrentplan`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.SET_CURRENT_PLAN_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.SET_CURRENT_PLAN_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getSortingMachines(sortingCenter) {
    return function (dispatch) {
        dispatch({ type: type.GET_SORTING_MACHINES })
        return adminServerInstance.get(`/sortmachine/getsortingmachines?sorting_center=${sortingCenter}`)
            .then(({ data }) => {
                dispatch({
                    type: type.GET_SORTING_MACHINES_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.GET_SORTING_MACHINES_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getSortingWarehouses(sortingCenter) {
    return function (dispatch) {
        dispatch({ type: type.GET_SORTING_WAREHOUSES })
        return adminServerInstance.get(`/sortmachine/getsortingwarehouses?sorting_center=${sortingCenter}`)
            .then(({ data }) => {
                dispatch({
                    type: type.GET_SORTING_WAREHOUSES_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.GET_SORTING_WAREHOUSES_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function handleRoutesUpdate(routes) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_ROUTES_UPDATE })
        return (
            dispatch({
                type: type.HANDLE_ROUTES_UPDATE,
                payload: routes
            })
        )
    }
}

export function handleSearchItems(center, code, mode) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_SEARCH_ITEMS })
        return (
            dispatch({
                type: type.HANDLE_SEARCH_ITEMS,
                payload: {
                    sortingCenter: center,
                    machineCode: code,
                    sortingType: mode
                }
            })
        )
    }
}

export function handlePresetRedux(preset, presetGroup) {
    return function (dispatch) {
        dispatch({ type: type.HANDLE_PRESET })
        return (
            dispatch({
                type: type.HANDLE_PRESET,
                payload: {
                    preset: preset,
                    presetGroup: presetGroup
                }
            })
        )
    }
}